export default ['Resty', Resty => Resty('sector_insiders')]
